import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant/Routes";
import Theme from "../../utils/Theme";
import { LoginContext } from "../../context/Login/LoginContext";
import {
  AiOutlineFileAdd,
  AiOutlineFileSearch,
  AiOutlineLogin,
  AiOutlineLogout,
  AiOutlineUserAdd,
} from "react-icons/ai";

export default function Menu() {
  const loginContext = useContext(LoginContext);

  const location = useLocation();

  const navigate = useNavigate();

  return (
    <div>
      <div
        className="fixed bottom-0 left-0 right-0 h-16  rounded-t-lg bg-lightSecondary dark:bg-darkSecondary dark:text-lightSecondary 
      grid grid-cols-3 place-items-stretch content-center gap-3 text-center p-2"
      >
        <Link to={ROUTES.INQUIRY}>
          <p
            className={`font-bold sm:text-md text-sm  cursor-pointer border-2 p-3 border-yellow-400 rounded-lg ${
              location.pathname == ROUTES.INQUIRY
                ? "bg-yellow-400 text-darkTextPrimary"
                : "text-yellow-400"
            }`}
          >
            <div className="flex items-center justify-evenly">
              <p>استعلام</p>
              <AiOutlineFileSearch className="text-xl" />
            </div>
          </p>
        </Link>
        {!loginContext.loginState ? (
          <>
            <Link to={ROUTES.LOGIN}>
              <p
                className={`font-bold sm:text-md  text-sm cursor-pointer border-2 p-3 border-green-700 rounded-lg ${
                  location.pathname == ROUTES.LOGIN
                    ? "bg-green-700 text-darkTextPrimary"
                    : "text-green-700"
                }`}
              >
                <div className="flex items-center justify-evenly">
                  <p>ورود</p>
                  <AiOutlineLogin className="text-xl" />
                </div>
              </p>
            </Link>
            <Link to={ROUTES.SIGNUP}>
              <p
                className={`font-bold sm:text-md text-sm cursor-pointer border-2 p-3 border-blue-700 rounded-lg ${
                  location.pathname == ROUTES.SIGNUP
                    ? "bg-blue-700 text-darkTextPrimary"
                    : "text-blue-700"
                }`}
              >
                <div className="flex items-center justify-evenly">
                  <p>ثبت نام</p>
                  <AiOutlineUserAdd className="text-xl" />
                </div>
              </p>
            </Link>
          </>
        ) : (
          <>
            <Link to={ROUTES.ADDPAKAT}>
              <p
                className={`font-bold sm:text-md text-sm cursor-pointer border-2 p-3 border-green-700 rounded-lg ${
                  location.pathname == ROUTES.ADDPAKAT
                    ? "bg-green-700 text-darkTextPrimary"
                    : "text-green-700"
                }`}
              >
                <div className="flex items-center justify-evenly">
                  <p>پاکت</p>
                  <AiOutlineFileAdd className="text-xl" />
                </div>
              </p>
            </Link>
            <p
              className={`font-bold sm:text-md text-sm cursor-pointer border-2 p-3 border-red-700 rounded-lg text-red-700`}
              onClick={() => {
                loginContext.logout();
                navigate(ROUTES.INQUIRY);
              }}
            >
              <div className="flex items-center justify-evenly">
                <p>خروج</p>
                <AiOutlineLogout className="text-xl" />
              </div>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
